<template>
   <div class="bg-light pt-3 pt-lg-5 pb-5">
      <b-container fluid>
         <b-row>
            <b-col cols="12" lg="3" xl="2" class="p-0">
               <DashUserNav></DashUserNav>
            </b-col>
            <b-col cols="12" lg="9" xl="10" class="pl-3 pl-lg-3 mt-3">
               <el-tabs v-model="activeTab" @tab-click="setTab">

                  <!-- Overview tab | Visão Geral tab -->
                  <el-tab-pane label="Minhas Bicicletas" name="minhas-bicicletas">

                     <div v-if="activeTab === 'minhas-bicicletas'">
                        <Overview/>
                     </div>
                  </el-tab-pane>

                  <!-- Books tab | Reservas tab -->
                  <el-tab-pane
                     name="pedidos"
                     v-if="this.$store.state.user.data.bikes.length"
                  >
                     <el-badge
                        :hidden="newOrdersQuery === 0"
                        slot="label"
                        :value="newOrdersQuery"
                        class="item"
                     >
                        <span>Reservas</span>
                     </el-badge>
                     <div v-if="activeTab === 'pedidos'">
                        <Books page-title="Reservas"/>
                     </div>

                  </el-tab-pane>

                  <!-- Transaction tab | Transações tab -->
<!--                  <el-tab-pane label="Extrato" name="extrato">
                     <div v-if="activeTab === 'extrato'">
                        <Extract/>
                     </div>
                  </el-tab-pane>-->

               </el-tabs>

            </b-col>
         </b-row>
      </b-container>

   </div>
</template>

<script>
import DashUserNav from "@/components/DashUserNav";
import Overview from './Overview';
import Books from './Books';
import UserService from "@/services/user.service";

export default {
   name: 'MyBikes',
   components: {
      DashUserNav,
      Overview,
      Books,
   },
   data() {
      return {
         activeTab: this.$route.params.page,
         url: '',
         user: {},
         approvedDigitalAccount: false
      }
   },

   async mounted() {

      if (!this.userData.data._id) await this.getUser();
      this.user = this.userData.data


      this.approvedDigitalAccount = true

   },

   methods: {

      //Obtem os dados do usuário.
      async getUser() {
         await this.$store.dispatch('user/get', await UserService.getUserData())
      },

      setTab(targetName) {
         this.$router.push(targetName.name)
      }
   },

   computed: {

      currentUser() {
         return this.$store.state.auth.user;
      },

      userData() {
         return this.$store.state.user
      },

      totalBikes() {
         return this.$store.state.bike.totalBikes;
      },

      newOrdersQuery() {
         return this.$store.state.order.newOrders;
      },


   },
   watch: {
      '$route.params.page': {
         handler: function (page) {

            this.activeTab = page

         },
         deep: true,
         immediate: true
      }
   }
};
</script>
